import "../../../styles/requests.css";
function RequestItemList({ requestData }) {
  console.log("REQUEST DATA:", requestData);
  const getUserId = () =>
    localStorage.getItem("userDetails")
      ? JSON.parse(localStorage.getItem("userDetails")).id
      : null;
  const handleViewBtnClick = (link_id, request_type) => {
    window.location.href = `/requests?p=view-request-detail&t=${request_type}&r=${link_id}&u=${getUserId()}&r_url=${
      window.location.href
    }`;
  };

  console.log("REQUEST DATA:", requestData);

  if (requestData?.request_type === "CCAR") {
    console.log("CCAR DATA:", requestData);
  }

  const requestType =
    requestData?.request_type === "ePR" ? "Request" : requestData?.request_type;
  return (
    <div
      className="request-item--list-container"
      onClick={() =>
        handleViewBtnClick(requestData?.id, requestData?.request_type)
      }
    >
      <div className="request-item--row">
        <div className="request--item-logo">
          <i className="fa fa-file-text-o fa-4x" aria-hidden="true"></i>
        </div>
        <div className="">
          <div className="request-ref-no">
            <h1>{requestData?.request_id}</h1>
          </div>
          <div className="request--detail">
            <div className="request--detail-item">
              <span>Request Type:&nbsp;</span>
              <span>{requestType}</span>
            </div>
            <div className="request--detail-item">
              <span className="">Date & Time Requested:&nbsp;</span>
              <span className="">{requestData?.date}</span>
            </div>
            {requestData?.request_type === "ePR" && (
              <div className="request--detail-item">
                <span className="">Total Cost:&nbsp;</span>
                <span className="">{requestData?.total_cost}</span>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="request--detail-status">
        <div
          className={`status ${
            requestData?.status === "Approved"
              ? "approved"
              : requestData?.status === "Denied"
              ? "denied"
              : "pending"
          } request--item-approval-status`}
        >
          <span>{requestData?.status}</span>
        </div>
      </div>
    </div>
  );
}

export default RequestItemList;
